module.exports = __webpack_public_path__ + "media/components/lesson3/statics/sendMessage-deeb276442b4c4d19879406b14929a7e.png";